<h3 mat-dialog-title class="title-layout"> Duplicated Model Variants Error </h3>

<div mat-dialog-content>
  <div *ngIf="data.dup_list">
    <p>
      Pitch <span style="font-weight: 500;">{{pitch_id}}</span> has model variants that are assigned to more than one pitch variant.
    </p>

    <table class="dup-table">
        <thead>
            <tr>
            <th>Pitch Variant Names</th>
            <th>Model Variant Names</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let variant of variantNames">
            <td>{{ variant }}</td>
            <td>
                <span *ngFor="let model of getModelNames(variant); let i = index">
                {{ model }}<span *ngIf="i < getModelNames(variant).length - 1">, </span>
                </span>
            </td>
            </tr>
        </tbody>
        </table>
  </div>
</div>
